import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { format, parseISO, differenceInDays } from 'date-fns';

const { FiX, FiUser, FiCalendar, FiMail, FiDollarSign, FiClock } = FiIcons;

const CalendarDetailModal = ({ isOpen, onClose, property, leaseStart, leaseEnd }) => {
  if (!isOpen || !property) return null;

  const daysTotal = differenceInDays(parseISO(leaseEnd), parseISO(leaseStart));
  const totalRent = (property.rentRate / 30) * daysTotal;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in duration-200">
        <div className="bg-indigo-600 p-6 text-white relative">
          <button onClick={onClose} className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors">
            <SafeIcon icon={FiX} size={24} />
          </button>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-white/20 rounded-lg">
              <SafeIcon icon={FiCalendar} />
            </div>
            <span className="text-sm font-bold uppercase tracking-widest opacity-80">Booking Details</span>
          </div>
          <h2 className="text-2xl font-bold">{property.name}</h2>
          <p className="text-indigo-100 text-sm mt-1">{property.address}</p>
        </div>

        <div className="p-6 space-y-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-gray-100 rounded-xl flex items-center justify-center text-gray-500">
              <SafeIcon icon={FiUser} />
            </div>
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider">Primary Tenant</p>
              <p className="font-bold text-gray-900">{property.tenantName || 'N/A'}</p>
              <p className="text-sm text-gray-500">{property.tenantEmail}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Check In</p>
              <div className="flex items-center gap-2 text-gray-900 font-bold">
                <SafeIcon icon={FiClock} className="text-indigo-600" size={14} />
                {format(parseISO(leaseStart), 'MMM dd, yyyy')}
              </div>
            </div>
            <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Check Out</p>
              <div className="flex items-center gap-2 text-gray-900 font-bold">
                <SafeIcon icon={FiClock} className="text-indigo-600" size={14} />
                {format(parseISO(leaseEnd), 'MMM dd, yyyy')}
              </div>
            </div>
          </div>

          <div className="p-4 bg-indigo-50 rounded-xl border border-indigo-100 flex items-center justify-between">
            <div>
              <p className="text-[10px] font-bold text-indigo-400 uppercase tracking-wider mb-1">Estimated Revenue</p>
              <div className="text-xl font-black text-indigo-700">
                ${Math.round(totalRent).toLocaleString()}
              </div>
            </div>
            <div className="text-right text-xs text-indigo-500 font-medium">
              {daysTotal} Nights <br />
              @ ${Math.round(property.rentRate / 30)}/day
            </div>
          </div>

          <div className="flex gap-3">
            <button 
              onClick={() => window.location.href = `mailto:${property.tenantEmail}`}
              className="flex-1 py-3 bg-gray-900 text-white font-bold rounded-xl hover:bg-black transition flex items-center justify-center gap-2"
            >
              <SafeIcon icon={FiMail} /> Contact
            </button>
            <button 
              onClick={onClose}
              className="flex-1 py-3 border border-gray-200 text-gray-600 font-bold rounded-xl hover:bg-gray-50 transition"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarDetailModal;